
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/kart",
      function () {
        return require("private-next-pages/kart.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/kart"])
      });
    }
  